import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Button,
  Collapse,
  Form,
  Input,
  InputNumber,
  Select,
  Modal,
  Checkbox,
  Progress,
} from "antd";
import {
  UserOutlined,
  EnvironmentOutlined,
  BankOutlined,
  HeartOutlined,
  HomeOutlined,
  ShopOutlined,
  DollarOutlined,
  FundOutlined,
  GlobalOutlined,
  WalletOutlined,
  CalculatorOutlined,
  MedicineBoxOutlined,
  AuditOutlined,
  FileTextOutlined,
  CheckCircleFilled,
  FilePdfOutlined,
  DownloadOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import GeneralInformation from "./GeneralInformation";
import Residency from "./Residency";
import BankAccountDetails from "./BankAccountDetails";
import DayCareExpense from "./DayCareExpense";
import RentalIncomeExpense from "./RentalIncomeExpense";
import SelfEmployment from "./SelfEmployment";
import EstimatedTaxPayments from "./EstimatedTaxPayments";
import FbarFatca from "./FbarFatca";
import OtherIncome from "./OtherIncome";
import AdjustmentIncome from "./AdjustmentIncome";
import MedicalExpenses from "./MedicalExpenses";
import TaxPaid from "./TaxPaid";
import Documents from "./Document's";
import localStorageContent from "../../../utils/localstorage";
import { initGetLead } from "../../../store/actions/creators";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./styles.scss";
import { IInitialState } from "../../../store/reducers/models";
import {
  clearLeadDetails,
  clearSections,
  setError,
} from "../../../store/reducers";
import Comments from "../../../components/Comments";
import TextArea from "antd/es/input/TextArea";
import LeadService from "../../../services/Lead.services";
import ReviewSection from "../ReviewSection";
import SubmissionSections from "../SubmissionSection";
import IncomeInformation from "./IncomeInformation";
import BackToAssign from "../BacktoAssign";
import BackToAssignList from "../BacktoAssign/BackToAssignList";
import { toolbarConfigs } from "../../../components/CommentBox/constants";
import RichTextEditor from "react-rte";
const { Panel } = Collapse;

const Lead = () => {
  const [leadId, setLeadId] = useState<null | string>(null);
  const [comments, setComments] = useState<any[]>([]);
  const [reviewComments, setReviewComments] = useState<any[]>([]);
  const [mergedComments, setMergedComments] = useState<any[]>([]);
  const [commentValue, setCommentValue] = useState<any>(
    RichTextEditor.createEmptyValue(),
  );
  const [reviewFile, setReviewFile] = useState<any>(null);
  const [panels, setPanels] = useState<any[number]>([0]);
  const [showBackStepModal, setBackStepModal] = useState<boolean>(false);
  const [currentBackStepDep, setCurrentBackStepDep] = useState<any>(null);
  const [isVerified, setIsVerified] = useState(false);
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsVerified(e.target.checked);
  };

  const [currentBackStepObj, setCurrentBackStepObj] = useState<any>({
    deptId: null,
    comment: "",
  });
  const gloablStore = useSelector((state: any) => state.store);
  const { leadData, selectedSections }: IInitialState = gloablStore;
  const userData = localStorageContent.getUserData();
  const fileInputRef: any = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const report = location.state;
  const isFromReport = report === "report" ? true : false;
  const params: any = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const {
    createComment,
    getComments,
    createReview,
    getReviews,
    submissionBack,
    submissionNext,
  } = LeadService;

  const [hideCloneButton, setHideCloneButton] = useState(false);
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);
  const [isSubmittingReview, setIsSubmittingReview] = useState(false);
  const [isSubmittingBack, setIsSubmittingBack] = useState(false);
  const [isSubmittingNext, setIsSubmittingNext] = useState(false);

  const isPaymentIncomplete =
    leadData?.department_id === 6 &&
    Number(leadData?.client_payment_status) === 5;

  useEffect(() => {
    setHideCloneButton(location.pathname.includes("leads/edit"));

    if (location.pathname.includes("edit") && params.id) {
      setLeadId(params.id);
      dispatch(initGetLead(params.id));
    }
  }, [location, params.id]);

  useEffect(() => {
    const cloneLeadidFromSession = sessionStorage.getItem("clonenewleadid");

    if (cloneLeadidFromSession !== null) {
      const leadId = Number(cloneLeadidFromSession);

      if (!isNaN(leadId) && leadId > 0) {
        setLeadId(cloneLeadidFromSession);
        dispatch(initGetLead(leadId));
      }
    }

    //sessionStorage.removeItem("clonenewleadid");
  }, []);

  const panelItems: any = [
    {
      Component: GeneralInformation,
      header: "General Information",
      icon: UserOutlined,
      verifyKey: "personel_info_verified",
      accessNo: 0,
      props: { isFromReport: isFromReport, hideCloneButton: hideCloneButton },
    },
    {
      Component: Residency,
      header: "States (US) of Residency",
      icon: EnvironmentOutlined,
      verifyKey: "residency_states_verified",
      accessNo: 1,
      props: { isFromReport: isFromReport },
    },
    {
      Component: BankAccountDetails,
      header: "Bank Account Details",
      icon: BankOutlined,
      verifyKey: "bank_details_verified",
      accessNo: 2,
      props: { isFromReport: isFromReport },
    },
    {
      Component: DayCareExpense,
      header: "Day Care Expense",
      icon: HeartOutlined,
      verifyKey: "daycare_expenses_verified",
      accessNo: 3,
      props: { isFromReport: isFromReport },
    },
    {
      Component: RentalIncomeExpense,
      header: "Rental Income and Expenses",
      icon: HomeOutlined,
      verifyKey: "rental_income_verified",
      accessNo: 4,
      props: { isFromReport: isFromReport },
    },
    {
      Component: SelfEmployment,
      header: "Self Employment Information",
      icon: ShopOutlined,
      verifyKey: "self_employment_verified",
      accessNo: 5,
      props: { isFromReport: isFromReport },
    },
    {
      Component: EstimatedTaxPayments,
      header: "Estimated Tax Payments",
      icon: DollarOutlined,
      verifyKey: "estimated_tax_verified",
      accessNo: 6,
      props: { isFromReport: isFromReport },
    },
    {
      Component: IncomeInformation,
      header: "Income Information",
      icon: FundOutlined,
      verifyKey: "income_information_verified",
      accessNo: 13,
      props: { isFromReport: isFromReport },
    },
    {
      Component: FbarFatca,
      header: "FBAR / FATCA",
      icon: GlobalOutlined,
      verifyKey: "fbar_fatca_verified",
      accessNo: 7,
      props: { isFromReport: isFromReport },
    },
    {
      Component: OtherIncome,
      header: "Other Income",
      icon: WalletOutlined,
      verifyKey: "other_income_verified",
      accessNo: 8,
      props: { isFromReport: isFromReport },
    },
    {
      Component: AdjustmentIncome,
      header: "Adjustments Income",
      icon: CalculatorOutlined,
      verifyKey: "adjustmenst_income_verified",
      accessNo: 9,
      props: { isFromReport: isFromReport },
    },
    {
      Component: MedicalExpenses,
      header: "Medical Expenses",
      icon: MedicineBoxOutlined,
      verifyKey: "medical_expenses_verified",
      accessNo: 10,
      props: { isFromReport: isFromReport },
    },
    {
      Component: TaxPaid,
      header: "Taxes Paid",
      icon: AuditOutlined,
      verifyKey: "taxes_paid_verified",
      accessNo: 11,
      props: { isFromReport: isFromReport },
    },
    {
      Component: Documents,
      header: "Documents",
      icon: FileTextOutlined,
      verifyKey: "documents_verified",
      accessNo: 12,
      props: { isFromReport: isFromReport },
    },
  ];

  const isFormSubmitted = useCallback(
    (key: string) => {
      if (leadData && leadData[key] && leadData[key] === "1") {
        return true;
      }

      return false;
    },
    [leadData],
  );

  const completedCount = panelItems.filter(({ verifyKey }: any) =>
    isFormSubmitted(verifyKey),
  ).length;
  const totalCount = panelItems.length;
  const progressPercent = Math.round((completedCount / totalCount) * 100);

  const finalSteps = () => {
    let showSubmission = false;
    const keysToValidate = [
      "bank_details_verified",
      "personel_info_verified",
      "residency_states_verified",
      "daycare_expenses_verified",
      "rental_income_verified",
      "self_employment_verified",
      "estimated_tax_verified",
      "fbar_fatca_verified",
      "other_income_verified",
      "adjustmenst_income_verified",
      "medical_expenses_verified",
      "taxes_paid_verified",
      "documents_verified",
      "income_information_verified",
    ];

    switch (true) {
      // case userData.departmentId === 2 && keysToValidate.every((key) => leadData[key] === '1') : // uncomment this code in future if verify functionality needed
      //   showSubmission = true;
      //   break;
      case userData.departmentId === 2 && leadData !== null:
        showSubmission = true;
        break;
      case userData.departmentId === 3 && leadData !== null:
        showSubmission = true;
        break;
      case userData.departmentId === 4 &&
        leadData?.actual_amount > 0 &&
        comments.length > 0 &&
        comments.some((comment: any) => comment.type === "2"):
        showSubmission = true;
        break;
      case userData.departmentId === 5 && leadData?.service_charge > 0:
        showSubmission = true;
        break;
      case userData.departmentId === 6 &&
        leadData?.lead_type === "1" &&
        leadData?.online_final_attachments !== null &&
        leadData?.online_final_attachments !== "":
        showSubmission = true;
        break;
      case userData.departmentId === 7 &&
        leadData?.lead_type === "2" &&
        leadData?.online_offline_attachments !== null &&
        leadData?.online_offline_attachments !== "":
        showSubmission = true;
        break;
      case leadData && leadData?.online_final_attachments !== "":
        showSubmission = true;
        break;
      default:
        return false;
    }

    return showSubmission;
  };

  const fetchComments = async () => {
    try {
      const response = await getComments(leadId, userData?.departmentId);
      if (response && response?.data?.length > 0) {
        setComments(response.data);
      }
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const submitComment = async (values: any) => {
    if (isSubmittingComment) return;
    try {
      if (commentValue.toString("html") === "<p><br></p>") {
        dispatch(
          setError({
            status: true,
            type: "error",
            message: "Please provide comment",
          }),
        );
        return;
      }
      setIsSubmittingComment(true);
      const copyValues: any = { comment: commentValue.toString("html") };
      if (selectedSections.length > 0) {
        copyValues.sections = selectedSections.toString();
      }
      const response = await createComment(leadId, copyValues);
      dispatch(
        setError({ status: true, type: "success", message: response?.message }),
      );
      setCommentValue(RichTextEditor.createEmptyValue());
      dispatch(clearSections(""));
      await fetchComments();
      dispatch(initGetLead(leadId));
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    } finally {
      setIsSubmittingComment(false);
    }
  };

  const submitReviews = async () => {
    if (isSubmittingReview) return;
    try {
      setIsSubmittingReview(true);
      const formData = new FormData();
      formData.append("comment", commentValue.toString("html"));
      if (reviewFile) formData.append("file", reviewFile);
      const response = await createReview(leadId, formData);
      dispatch(
        setError({ status: true, type: "success", message: response?.message }),
      );
      setCommentValue(RichTextEditor.createEmptyValue());
      setReviewFile("");
      if (fileInputRef.current) fileInputRef.current.value = null;
      await fetchComments();
      dispatch(initGetLead(leadId));
    } catch (err: any) {
      setReviewFile("");
      dispatch(setError({ status: true, type: "error", message: err }));
    } finally {
      setIsSubmittingReview(false);
    }
  };

  const onChangeSubmitBack = (value: any, name: any) => {
    setCurrentBackStepObj((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const submitBackStep = async () => {
    if (isSubmittingBack) return;
    try {
      setIsSubmittingBack(true);
      let copyvalues: any = { ...currentBackStepObj };
      const response = await submissionBack(leadId, copyvalues);
      if (response) {
        setBackStepModal(false);
        setCurrentBackStepDep(null);
        dispatch(
          setError({
            status: true,
            type: "success",
            message: response?.message,
          }),
        );
        setCurrentBackStepObj({
          deptId: null,
          comment: "",
        });
        navigate("/leads");
      }
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    } finally {
      setIsSubmittingBack(false);
    }
  };

  const handleBackSteps = async () => {
    setBackStepModal(true);
    // if(userData?.role === '3' && (userData?.departmentId === 4 || userData?.departmentId === 5)){
    //   setBackStepModal(true)
    // }
    // else{
    //   submitBackStep()
    // }
  };

  const handleNextSteps = async () => {
    if (isSubmittingNext) return;
    try {
      setIsSubmittingNext(true);
      const response = await submissionNext(leadId, { status: "2" });
      if (response) {
        dispatch(
          setError({
            status: true,
            type: "success",
            message: response?.message,
          }),
        );
        navigate("/leads");
      }
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    } finally {
      setIsSubmittingNext(false);
    }
  };

  useEffect(() => {
    if (location.pathname.includes("edit") && Object.keys(params).length > 0) {
      setLeadId(params.id);
      dispatch(initGetLead(params.id));
    }

    return () => {
      dispatch(clearLeadDetails(""));
    };
  }, [location]);

  useEffect(() => {
    if (leadData && userData && userData?.departmentId !== 1) {
      fetchComments();
    }
  }, [leadData, userData?.departmentId]);

  return (
    <div className="user-details">
      <>
        {Number(leadData?.lead_status) === 7 && (
          <div className="tax-docs-card">
            <div className="tax-docs-card__header">
              <FileTextOutlined className="tax-docs-card__header-icon" />
              <span>Tax Documents</span>
            </div>

            <div className="tax-docs-card__body">
              {/* Selected review tax files */}
              {leadData.selected_review && (
                <div className="tax-docs-section">
                  <p className="tax-docs-section__label">
                    Selected Review Tax Files
                  </p>
                  <a
                    className="tax-docs-file-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        leadData.selected_review.trim(),
                        "_blank",
                        "noopener,noreferrer",
                      );
                    }}
                  >
                    <FilePdfOutlined />
                    <span>
                      {leadData.selected_review
                        .split("/")
                        .pop()
                        .replace(/%20/g, "") || "Tax file"}
                    </span>
                    <DownloadOutlined className="tax-docs-file-link__dl" />
                  </a>
                </div>
              )}

              {/* Online and Offline tax files */}
              {leadData.online_offline_attachments && (
                <div className="tax-docs-section">
                  <p className="tax-docs-section__label">
                    Online & Offline Tax Files
                  </p>
                  <a
                    className="tax-docs-file-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        leadData.online_offline_attachments.trim(),
                        "_blank",
                        "noopener,noreferrer",
                      );
                    }}
                  >
                    <FilePdfOutlined />
                    <span>
                      {leadData.online_offline_attachments
                        .split("/")
                        .pop()
                        .replace(/%20/g, "") || "Tax file"}
                    </span>
                    <DownloadOutlined className="tax-docs-file-link__dl" />
                  </a>
                </div>
              )}

              {/* Final Tax Files */}
              {leadData.online_final_attachments && (
                <div className="tax-docs-section">
                  <p className="tax-docs-section__label">Final Tax Files</p>
                  <div className="tax-docs-file-list">
                    {leadData.online_final_attachments
                      .split(",")
                      .map((file: any, index: any) => (
                        <a
                          key={index}
                          className="tax-docs-file-link"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(
                              file.trim(),
                              "_blank",
                              "noopener,noreferrer",
                            );
                          }}
                        >
                          <FilePdfOutlined />
                          <span>
                            {file.split("/").pop().replace(/%20/g, "") ||
                              `Tax file ${index + 1}`}
                          </span>
                          <DownloadOutlined className="tax-docs-file-link__dl" />
                        </a>
                      ))}
                  </div>
                </div>
              )}

              {/* Charges */}
              <div className="tax-docs-charges">
                <div className="tax-docs-charges__item">
                  <CreditCardOutlined className="tax-docs-charges__icon tax-docs-charges__icon--service" />
                  <div>
                    <p className="tax-docs-charges__label">Service Charge</p>
                    <p className="tax-docs-charges__value">
                      ${leadData.service_charge}
                    </p>
                  </div>
                </div>
                <div className="tax-docs-charges__item">
                  <DollarOutlined className="tax-docs-charges__icon tax-docs-charges__icon--actual" />
                  <div>
                    <p className="tax-docs-charges__label">Actual Charge</p>
                    <p className="tax-docs-charges__value">
                      ${leadData.actual_amount}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>

      {showBackStepModal && (
        <BackToAssign
          submitBackStep={submitBackStep}
          setCurrentBackStepDep={setCurrentBackStepDep}
          showBackStepModal={showBackStepModal}
          setBackStepModal={setBackStepModal}
          onChangeSubmitBack={onChangeSubmitBack}
        />
      )}
      <div className="user-details__collapses-menu">
        <div>
          <SubmissionSections
            leadData={leadData}
            fetchReviews={fetchComments}
          />
          <ReviewSection leadData={leadData} fetchReviews={fetchComments} />
        </div>
        <div className="lead-form-header">
          <div className="lead-form-header__title-row">
            <div className="lead-form-header__title">
              <FileTextOutlined className="lead-form-header__title-icon" />
              Fill Lead Tax Information
            </div>
            <div className="lead-form-header__progress-wrap">
              <Button
                type="primary"
                className="custom-btn"
                onClick={() =>
                  navigate(`/leads/edit/${leadData?.lead_id}/documents-storage`)
                }
              >
                Documents View
              </Button>
            </div>
          </div>
        </div>

        <Collapse accordion defaultActiveKey={["0"]} className="lead-collapse">
          {panelItems.map(
            (
              {
                header,
                Component,
                verifyKey,
                accessNo,
                props,
                icon: SectionIcon,
              }: any,
              index: any,
            ) => {
              const verified = isFormSubmitted(verifyKey);
              const panelHeader = (
                <div className="lead-panel-header">
                  <span className="lead-panel-header__num">{index + 1}</span>
                  <SectionIcon className="lead-panel-header__icon" />
                  <span className="lead-panel-header__title">{header}</span>
                  {verified && (
                    <CheckCircleFilled className="lead-panel-header__check" />
                  )}
                </div>
              );
              return (
                <Panel
                  header={panelHeader}
                  key={index}
                  className={
                    verified ? "lead-panel lead-panel--verified" : "lead-panel"
                  }
                >
                  <Component {...props} />
                </Panel>
              );
            },
          )}
        </Collapse>
        {/* <div className='user-details__collapses-menu__header--multi-section-search'> */}
        {/* <Checkbox.Group options={panelItems.slice(1, panelItems.length).map((panel: any) => ({
                label: panel.header,
                value: panel.header
              }))} onChange={(e: any) => setPanels([...e])}/> */}
        {/* <Select
              mode="multiple"
              allowClear
              showSearch
              style={{ width: '100%', marginBottom: 10, cursor: 'pointer'}}
              placeholder="Select section"
              onChange={(e: any) => setPanels([...e])}
              options={panelItems.slice(1, panelItems.length).map((panel: any) => ({
                label: panel.header,
                value: panel.header
              }))}
          /> */}
        {/* </div> */}
        {leadData && (
          <>
            {comments?.length > 0 && (
              <div className="lead-comments-section">
                <div className="lead-comments-section__title">
                  {(userData?.role === "3" || userData?.role === "2") &&
                  userData?.departmentId === 4
                    ? "Reviews"
                    : "Comments"}
                </div>
                <Comments comments={comments} />
              </div>
            )}

            {userData?.role === "3" &&
              leadData?.department_id === userData.departmentId && (
                <div className="lead-message-section">
                  <div className="lead-message-section__title">
                    Message to Client
                  </div>
                  {userData?.departmentId !== 3 &&
                    selectedSections.length > 0 && (
                      <ul className="comment-details">
                        {selectedSections.map((section: any, index: number) => (
                          <li key={index}>{section}</li>
                        ))}
                      </ul>
                    )}

                  <Form form={form} onFinish={submitComment}>
                    <RichTextEditor
                      value={commentValue}
                      onChange={(e: any) => setCommentValue(e)}
                      toolbarConfig={toolbarConfigs}
                    />
                    <Form.Item
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        margin: "10px 0",
                      }}
                    >
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={isSubmittingComment}
                        disabled={isSubmittingComment}
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>

                  {(userData?.departmentId === 4 ||
                    userData?.departmentId === 5) && (
                    <Form form={form} layout="vertical">
                      <Form.Item
                        name="file"
                        label="Upload Tax File"
                        initialValue={reviewFile}
                      >
                        <Input
                          name="taxFile"
                          type={"file"}
                          ref={fileInputRef}
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e: any) =>
                            setReviewFile(e.target.files[0])
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          type="primary"
                          onClick={submitReviews}
                          loading={isSubmittingReview}
                          disabled={isSubmittingReview}
                        >
                          Submit
                        </Button>
                      </Form.Item>
                    </Form>
                  )}
                </div>
              )}

            <div>
              <BackToAssignList leadData={leadData} />
            </div>
            {isPaymentIncomplete && (
              <p style={{ color: "#ff4d4f", marginTop: 8, textAlign: "right" }}>
                ⚠️ Final tax submission is disabled because full payment is not
                completed.
              </p>
            )}
            <div className="lead-action-bar">
              {/* LEFT — Back to assign */}
              <div className="lead-action-bar__left">
                {leadData?.lead_status !== "7" &&
                  userData?.role == "3" &&
                  leadData?.department_id == userData.departmentId &&
                  userData?.departmentId &&
                  [3, 4, 5, 6].includes(userData?.departmentId) && (
                    <Button
                      className="lead-action-bar__back-btn"
                      onClick={handleBackSteps}
                      loading={isSubmittingBack}
                      disabled={isSubmittingBack}
                    >
                      Back to assign
                    </Button>
                  )}
              </div>

              {/* RIGHT — Verified checkbox + Complete next steps */}
              <div className="lead-action-bar__right">
                {userData?.departmentId === 3 && finalSteps() && (
                  <label className="lead-action-bar__verify-check">
                    <input
                      type="checkbox"
                      checked={isVerified}
                      onChange={handleCheckboxChange}
                    />
                    <span>Verified lead</span>
                  </label>
                )}
                {finalSteps() &&
                  userData?.role == "3" &&
                  leadData?.department_id == userData.departmentId &&
                  leadData?.client_payment_status !== "3" && (
                    <Button
                      className="lead-action-bar__complete-btn"
                      onClick={handleNextSteps}
                      loading={isSubmittingNext}
                      disabled={
                        isSubmittingNext ||
                        (leadData?.department_id === 6 &&
                          leadData?.client_payment_status === "5") ||
                        (userData?.departmentId === 5 &&
                          (leadData?.paid_status === "0" ||
                            leadData?.paid_status === 0)) ||
                        (userData?.departmentId === 3 && !isVerified) ||
                        (leadData?.department_id === 4 &&
                          leadData.lead_type === null &&
                          comments?.filter(
                            (item) =>
                              item?.department_id === 4 &&
                              item?.attachment === "",
                          )?.length <= 0) ||
                        (leadData?.department_id === 6 &&
                          leadData.online_final_attachments === null) ||
                        !leadData.leadDocuments ||
                        leadData.leadDocuments.length === 0
                      }
                    >
                      {leadData?.department_id === 6
                        ? "Final tax submission"
                        : "Complete next steps"}
                    </Button>
                  )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Lead;
